const esLang = {
  title: 'Sanfer Conect@',
}
const enLang = {
  title: 'Sanfer Conect@',
}

export const langTexts = {
  es: esLang,
  en: enLang
}